import { ToolbarController } from './../../layout/toolbar/toolbar.controller';
import { ACTToolbarService } from 'src/app/angularJS/services/toolbar.service';
import { AboutService } from '../../services/about/about.service';

export class AboutController {
  public static $inject = ['ACTToolbarService', 'aboutService'];

  public actoraVersion: string;

  constructor(private toolbarService: ACTToolbarService, private aboutService: AboutService) {
    this.activate();
  }

  private activate() {
    this.toolbarService.getToolbar('primary').then((toolbar: ToolbarController) => {
      toolbar.setTitle('HEADING.ABOUT');
    });

    this.aboutService.getAppDetails().then((appDetails) => {
      this.actoraVersion = appDetails.actoraVersion;
    });
  }
}